import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import type { Tenant } from '@hyvay/shared-types';
import type { VideoListItem } from '../../services/video.service';
import { FONT_SANS, FONT_SERIF } from '../landing/landingData';

/**
 * Shared building blocks of the dashboard (design "HyVay Dashboard", 2026-11).
 * Pages import from here so the shell, toolbars and project cards stay identical.
 */

// ---------------------------------------------------------------- icons (design ICON / ICON_F)
export const ICON = {
    home: 'M4 10.6a2 2 0 0 1 .74-1.55l6-4.9a2 2 0 0 1 2.52 0l6 4.9A2 2 0 0 1 20 10.6V18a2 2 0 0 1-2 2h-3v-4.5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1V20H6a2 2 0 0 1-2-2z',
    projects: 'M3.5 7.5a2 2 0 0 1 2-2h3.6a2 2 0 0 1 1.4.6l1.3 1.3a2 2 0 0 0 1.4.6h5.3a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z',
    library: 'M6.5 4.5h11A2.5 2.5 0 0 1 20 7v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17V7a2.5 2.5 0 0 1 2.5-2.5z M4.6 16.4l4.1-4.1a1.5 1.5 0 0 1 2.1 0l5.6 5.6 M13.9 14.1l1.4-1.4a1.5 1.5 0 0 1 2.1 0l2.1 2.1 M15 9.3h.01',
    calendar: 'M6.5 5.5h11A2.5 2.5 0 0 1 20 8v9.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5V8a2.5 2.5 0 0 1 2.5-2.5z M4 10h16 M8.5 3.5v3.5 M15.5 3.5v3.5 M8.5 14h.01 M12 14h.01 M15.5 14h.01',
    analytics: 'M10.5 5.2A7.4 7.4 0 1 0 18.8 13.5h-7.1a1.2 1.2 0 0 1-1.2-1.2z M13.5 3.7a1 1 0 0 1 1.1-1A7.4 7.4 0 0 1 21.3 9.4a1 1 0 0 1-1 1.1h-5.6a1.2 1.2 0 0 1-1.2-1.2z',
    plug: 'M5.35 3.75h3.3A1.6 1.6 0 0 1 10.25 5.35v3.3A1.6 1.6 0 0 1 8.65 10.25H5.35A1.6 1.6 0 0 1 3.75 8.65V5.35A1.6 1.6 0 0 1 5.35 3.75z M5.35 13.75h3.3A1.6 1.6 0 0 1 10.25 15.35v3.3A1.6 1.6 0 0 1 8.65 20.25H5.35A1.6 1.6 0 0 1 3.75 18.65V15.35A1.6 1.6 0 0 1 5.35 13.75z M15.35 13.75h3.3A1.6 1.6 0 0 1 20.25 15.35v3.3A1.6 1.6 0 0 1 18.65 20.25H15.35A1.6 1.6 0 0 1 13.75 18.65V15.35A1.6 1.6 0 0 1 15.35 13.75z M16.1 3.6a1.3 1.3 0 0 1 1.8 0l2.5 2.5a1.3 1.3 0 0 1 0 1.8l-2.5 2.5a1.3 1.3 0 0 1-1.8 0l-2.5-2.5a1.3 1.3 0 0 1 0-1.8z',
    site: 'M6.5 4.5h11A2.5 2.5 0 0 1 20 7v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17V7a2.5 2.5 0 0 1 2.5-2.5z M4 9h16',
    video: 'M5.5 6h7A2.5 2.5 0 0 1 15 8.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 15.5v-7A2.5 2.5 0 0 1 5.5 6z M15 10.2l4.4-2.6a1 1 0 0 1 1.6.8v7.2a1 1 0 0 1-1.6.8L15 13.8',
    templates: 'M4 4h7v7H4z M13 4h7v4h-7z M13 10h7v10h-7z M4 13h7v7H4z',
    trash: 'M4.5 7h15 M9.5 7V4.5h5V7 M6.5 7l1 13h9l1-13',
    image: 'M7 4.5h10A2.5 2.5 0 0 1 19.5 7v10a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 17V7A2.5 2.5 0 0 1 7 4.5z M4.8 15.6l3.4-3.2a1.6 1.6 0 0 1 2.2 0l5.2 5 M13.8 14.4l1.4-1.3a1.6 1.6 0 0 1 2.2 0l1.9 1.8 M15 9.4h.01',
    doc: 'M8 3.5h5.2a2 2 0 0 1 1.4.6l3.3 3.3a2 2 0 0 1 .6 1.4V18a2.5 2.5 0 0 1-2.5 2.5H8A2.5 2.5 0 0 1 5.5 18V6A2.5 2.5 0 0 1 8 3.5z M13.5 3.8V7a1.5 1.5 0 0 0 1.5 1.5h3.2 M9 13h6 M9 16.5h4',
};
/** Filled variants for the active rail item (fill + optional stroke-only line and desk-coloured cut). */
export const ICON_F: Record<string, { fill: string; line?: string; cut?: string }> = {
    home: { fill: ICON.home },
    projects: { fill: ICON.projects },
    media: { fill: 'M6.5 4.5h11A2.5 2.5 0 0 1 20 7v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17V7a2.5 2.5 0 0 1 2.5-2.5z', cut: 'M4.6 16.4l4.1-4.1a1.5 1.5 0 0 1 2.1 0l5.6 5.6 M13.9 14.1l1.4-1.4a1.5 1.5 0 0 1 2.1 0l2.1 2.1 M15 9.3h.01' },
    scheduler: { fill: 'M6.5 5.5h11A2.5 2.5 0 0 1 20 8v9.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5V8a2.5 2.5 0 0 1 2.5-2.5z', line: 'M8.5 3.5v3.5 M15.5 3.5v3.5', cut: 'M5.5 10h13 M8.5 14h.01 M12 14h.01 M15.5 14h.01' },
    analytics: { fill: ICON.analytics },
    integration: { fill: ICON.plug },
};

export const Icon: React.FC<{ d: string; size?: number; sw?: number; style?: React.CSSProperties }> = ({ d, size = 16, sw = 1.9, style }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={style} aria-hidden="true"><path d={d} /></svg>
);
export const ArrowR: React.FC<{ size?: number }> = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" /></svg>
);
export const Chevron: React.FC<{ open?: boolean }> = ({ open }) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: `rotate(${open ? 180 : 0}deg)`, transition: 'transform 0.2s ease' }} aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
);
export const Check: React.FC = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--hv-mint-ink)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7" /></svg>
);
export const Dots: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5.5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="18.5" cy="12" r="1.6" /></svg>
);

// ---------------------------------------------------------------- formatting
export function fmtAgo(iso: string | Date | null | undefined): string {
    if (!iso) return '';
    const t = new Date(iso).getTime();
    const s = Math.max(0, (Date.now() - t) / 1000);
    if (s < 60) return 'Just now';
    if (s < 3600) { const m = Math.round(s / 60); return `${m} minute${m === 1 ? '' : 's'} ago`; }
    if (s < 86400) { const h = Math.round(s / 3600); return `${h} hour${h === 1 ? '' : 's'} ago`; }
    const d = Math.round(s / 86400);
    if (d === 1) return 'Yesterday';
    if (d < 7) return `${d} days ago`;
    if (d < 14) return 'Last week';
    if (d < 30) return `${Math.round(d / 7)} weeks ago`;
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
export const fmtDur = (sec: number | null | undefined) => {
    if (!sec || sec <= 0) return '';
    const s = Math.round(sec);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

// ---------------------------------------------------------------- projects (websites + videos)
export type ProjectKind = 'site' | 'video';
export type ProjectStatus = 'live' | 'ready' | 'draft' | 'building';
export interface DashProject {
    kind: ProjectKind;
    id: string;
    name: string;
    updatedAt: string;
    status: ProjectStatus;
    /** Site: screenshot; video: none (the card draws a frame). */
    thumb: string | null;
    /** Site only. */
    publishedUrl?: string | null;
    /** Video only. */
    aspect?: '9:16' | '1:1' | '16:9';
    caption?: string;
    durationSec?: number | null;
    /** Newest finished render (video). */
    renderUrl?: string | null;
}

const ASPECT = { portrait: '9:16', square: '1:1', landscape: '16:9' } as const;

export const siteToProject = (t: Tenant): DashProject => {
    const s = String(t.status || 'DRAFT').toUpperCase();
    return {
        kind: 'site', id: t.id, name: t.name, updatedAt: t.updatedAt, thumb: t.thumbnailUrl || null, publishedUrl: t.publishedUrl ?? null,
        status: s === 'PUBLISHED' ? 'live' : s === 'BUILDING' ? 'building' : 'draft',
    };
};
export const videoToProject = (v: VideoListItem): DashProject => {
    const first = v.spec?.scenes?.[0] as any;
    const caption = first?.title || first?.text || v.spec?.title || v.name;
    return {
        kind: 'video', id: v.id, name: v.name, updatedAt: v.updatedAt, thumb: null, aspect: ASPECT[v.format] || '9:16',
        caption: String(caption || '').slice(0, 60), durationSec: v.lastDone?.durationSec ?? null, renderUrl: v.lastDone?.url ?? null,
        status: v.lastDone ? 'ready' : 'draft',
    };
};

export const STATUS_WORD: Record<ProjectStatus, string> = { live: 'Live', ready: 'Ready', draft: 'Draft', building: 'Building' };
export const STATUS_DOT: Record<ProjectStatus, string> = { live: '#2E9E64', ready: '#2E9E64', draft: '#D98A64', building: '#C9A13B' };
/** Design TONE / FRAME for video cards (thumb background + mock frame size). */
const VIDEO_TONES = ['var(--hv-sand)', 'var(--hv-mint)', 'color-mix(in srgb,var(--hv-clay) 55%,var(--hv-card))'];
export const toneFor = (id: string) => VIDEO_TONES[[...id].reduce((n, c) => n + c.charCodeAt(0), 0) % VIDEO_TONES.length];
export const FRAME: Record<string, [number, number]> = { '9:16': [70, 124], '16:9': [168, 95], '1:1': [104, 104] };
export const FRAME_SM: Record<string, [number, number]> = { '9:16': [52, 92], '16:9': [130, 73], '1:1': [80, 80] };

// ---------------------------------------------------------------- shared dashboard state (provided by DashboardLayout)
export interface DashCtx {
    firstName: string;
    credits: number | null;
    refreshCredits: () => void;
    openTopUp: () => void;
    projects: DashProject[];
    projectsLoading: boolean;
    refreshProjects: () => Promise<void>;
    /** Open a site in the studio (full page load) or a video in its editor. */
    openProject: (p: DashProject) => void;
    /** Move to Trash (with confirm); refreshes the list. */
    trashProject: (p: DashProject) => Promise<void>;
    /** Home composer: switch to Video with this site as the source. */
    makeVideoFrom: (p: DashProject) => void;
    notify: (tone: 'success' | 'error' | 'warn', text: string) => void;
}
export const DashContext = createContext<DashCtx | null>(null);
export const useDash = () => {
    const c = useContext(DashContext);
    if (!c) throw new Error('useDash outside DashboardLayout');
    return c;
};

// ---------------------------------------------------------------- page parts
export const PageHead: React.FC<{ title: string; lead?: React.ReactNode; children?: React.ReactNode }> = ({ title, lead, children }) => (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
            <h1 style={{ margin: 0, fontFamily: FONT_SERIF, fontWeight: 400, fontSize: 32, lineHeight: 1, letterSpacing: '-0.008em', wordSpacing: '0.06em' }}>{title}</h1>
            {lead && <p style={{ margin: '8px 0 0', fontSize: 13.5, color: 'var(--hv-body)' }}>{lead}</p>}
        </div>
        {children}
    </div>
);

export const FillButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & { icon?: React.ReactNode }> = ({ icon, children, style, className, ...rest }) => (
    <button type="button" {...rest} className={`hv-btn-fill ${className ?? ''}`} style={{ display: 'flex', alignItems: 'center', gap: 8, height: 36, padding: '0 16px', borderRadius: 999, border: 0, background: 'var(--brand,#13422C)', color: '#FFFDF7', fontSize: 13.5, fontWeight: 700, cursor: rest.disabled ? 'default' : 'pointer', opacity: rest.disabled ? 0.6 : 1, whiteSpace: 'nowrap', ...style }}>
        {icon}{children}
    </button>
);
export const OutlineButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, style, className, ...rest }) => (
    <button type="button" {...rest} className={`hv-btn-out ${className ?? ''}`} style={{ display: 'flex', alignItems: 'center', gap: 7, height: 34, padding: '0 14px', borderRadius: 999, border: '1px solid var(--hv-line-2)', background: 'var(--hv-card)', color: 'var(--hv-ink)', fontSize: 13, fontWeight: 600, cursor: rest.disabled ? 'default' : 'pointer', opacity: rest.disabled ? 0.6 : 1, whiteSpace: 'nowrap', ...style }}>
        {children}
    </button>
);
export const PlusIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>;

/** Close a popover on outside click / Escape. */
export function useDismiss<T extends HTMLElement>(open: boolean, close: () => void) {
    const ref = useRef<T>(null);
    useEffect(() => {
        if (!open) return;
        // Triggers carry data-dismiss-ignore so a click on them toggles instead of close-then-reopen.
        const onDown = (e: MouseEvent) => {
            const t = e.target as Element;
            if (t?.closest?.('[data-dismiss-ignore]')) return;
            if (ref.current && !ref.current.contains(t)) close();
        };
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
        document.addEventListener('mousedown', onDown, true);
        document.addEventListener('keydown', onKey);
        return () => { document.removeEventListener('mousedown', onDown, true); document.removeEventListener('keydown', onKey); };
    }, [open, close]);
    return ref;
}

/** Design "Type All ▾" pill dropdown. */
export function FilterDropdown<V extends string>({ label, value, options, onChange, width = 200 }: { label: string; value: V; options: Array<[V, string]>; onChange: (v: V) => void; width?: number }) {
    const [open, setOpen] = useState(false);
    const ref = useDismiss<HTMLDivElement>(open, () => setOpen(false));
    const current = options.find((o) => o[0] === value)?.[1] ?? options[0]?.[1];
    return (
        <div ref={ref} style={{ position: 'relative', flex: 'none' }}>
            <button type="button" onClick={() => setOpen((o) => !o)} aria-haspopup="listbox" aria-expanded={open} className="hv-btn-out" style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap', height: 34, padding: '0 10px 0 13px', borderRadius: 999, border: `1px solid ${open ? 'var(--hv-brand-ink)' : 'var(--hv-line)'}`, background: 'var(--hv-card)', color: 'var(--hv-ink)', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                <span style={{ color: 'var(--hv-muted)', fontWeight: 500 }}>{label}</span>
                {current}
                <Chevron open={open} />
            </button>
            {open && (
                <div role="listbox" style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 30, width, padding: 6, borderRadius: 8, background: 'var(--hv-card)', border: '1px solid var(--hv-line)', boxShadow: '0 24px 44px -20px var(--hv-shadow)', animation: 'hvPop 0.18s ease both' }}>
                    {options.map(([v, l]) => (
                        <button key={v} type="button" role="option" aria-selected={v === value} onClick={() => { onChange(v); setOpen(false); }} className="hv-mi" style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '9px 10px', border: 0, borderRadius: 5, background: 'transparent', fontSize: 13.5, fontWeight: 500, color: 'var(--hv-ink)', cursor: 'pointer', textAlign: 'left' }}>
                            <span style={{ flex: 1 }}>{l}</span>
                            {v === value && <Check />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export type Layout = 'grid' | 'list';
export const ViewToggle: React.FC<{ value: Layout; onChange: (v: Layout) => void }> = ({ value, onChange }) => {
    const btn = (on: boolean): React.CSSProperties => ({ width: 32, height: 28, border: 0, borderRadius: 999, background: on ? 'var(--hv-card)' : 'transparent', color: on ? 'var(--hv-ink)' : 'var(--hv-muted)', boxShadow: on ? '0 2px 5px -2px var(--hv-shadow)' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' });
    return (
        <div style={{ display: 'flex', gap: 2, padding: 3, borderRadius: 999, background: 'var(--hv-page-2)', border: '1px solid var(--hv-line)' }}>
            <span className="hv-tip" style={{ position: 'relative', display: 'flex' }}>
                <button type="button" onClick={() => onChange('grid')} aria-label="Grid view" aria-pressed={value === 'grid'} style={btn(value === 'grid')}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round"><rect x="4" y="4" width="6.5" height="6.5" rx="1.5" /><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5" /><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5" /><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5" /></svg>
                </button>
                <Tip>Grid view</Tip>
            </span>
            <span className="hv-tip" style={{ position: 'relative', display: 'flex' }}>
                <button type="button" onClick={() => onChange('list')} aria-label="List view" aria-pressed={value === 'list'} style={btn(value === 'list')}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 6.5h11M9 12h11M9 17.5h11M4.5 6.5h.01M4.5 12h.01M4.5 17.5h.01" /></svg>
                </button>
                <Tip>List view</Tip>
            </span>
        </div>
    );
};
export const Tip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <span className="hv-tip-b" style={{ position: 'absolute', bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)', whiteSpace: 'nowrap', padding: '5px 9px', borderRadius: 7, background: '#24262A', color: '#F3F2EC', fontSize: 11.5, fontWeight: 600, opacity: 0, pointerEvents: 'none', transition: 'opacity 0.15s ease', zIndex: 40 }}>{children}</span>
);

export const SearchBox: React.FC<{ value: string; onChange: (v: string) => void; placeholder: string }> = ({ value, onChange, placeholder }) => (
    <label className="hv-search hv-db-search" style={{ flex: '0 1 280px', minWidth: 180, display: 'flex', alignItems: 'center', gap: 9, height: 38, padding: '0 14px', borderRadius: 999, background: 'var(--hv-card)', border: '1px solid var(--hv-line)', color: 'var(--hv-muted)' }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4.2-4.2" /></svg>
        <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} style={{ flex: 1, minWidth: 0, border: 0, background: 'transparent', outline: 'none', fontSize: 13.5, color: 'var(--hv-ink)' }} />
        {value && (
            <button type="button" className="hv-clear" onClick={() => onChange('')} aria-label="Clear search" style={{ flex: 'none', width: 22, height: 22, marginRight: -6, borderRadius: 999, border: 0, background: 'var(--hv-page-2)', color: 'var(--hv-body)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
        )}
    </label>
);

/** Dashed "nothing here" box (design noProjects). */
export const EmptyBox: React.FC<{ title: string; text: React.ReactNode; action?: React.ReactNode }> = ({ title, text, action }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 18, padding: 22, borderRadius: 8, border: '1px dashed var(--hv-line-2)', background: 'var(--hv-card-2)', flexWrap: 'wrap' }}>
        <span style={{ flex: 'none', width: 44, height: 44, borderRadius: 14, background: 'var(--hv-mint)', color: 'var(--hv-mint-ink)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0l2.4 9.6L24 12l-9.6 2.4L12 24l-2.4-9.6L0 12l9.6-2.4z" /></svg>
        </span>
        <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontSize: 14.5, fontWeight: 700 }}>{title}</div>
            <div style={{ marginTop: 3, fontSize: 13.5, lineHeight: 1.55, color: 'var(--hv-body)' }}>{text}</div>
        </div>
        {action}
    </div>
);

/** "Coming soon" card for features without data yet. */
export const ComingSoon: React.FC<{ title: string; text: React.ReactNode }> = ({ title, text }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: '48px 24px', borderRadius: 8, border: '1px dashed var(--hv-line-2)', background: 'var(--hv-card-2)', textAlign: 'center' }}>
        <span style={{ fontFamily: FONT_SANS, fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', padding: '5px 11px', borderRadius: 999, background: 'var(--hv-mint)', color: 'var(--hv-mint-ink)' }}>COMING SOON</span>
        <div style={{ marginTop: 4, fontFamily: FONT_SERIF, fontSize: 26, lineHeight: 1.1 }}>{title}</div>
        <p style={{ margin: 0, maxWidth: 440, fontSize: 13.5, lineHeight: 1.6, color: 'var(--hv-body)' }}>{text}</p>
    </div>
);

export const SectionHead: React.FC<{ title: string; action?: React.ReactNode }> = ({ title, action }) => (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 500, letterSpacing: '-0.005em', color: 'var(--hv-ink)' }}>{title}</h2>
        <div style={{ flex: 1 }} />
        {action}
    </div>
);
export const TextLink: React.FC<{ onClick: () => void; children: React.ReactNode }> = ({ onClick, children }) => (
    <button type="button" onClick={onClick} className="hv-link" style={{ display: 'flex', alignItems: 'center', gap: 6, height: 32, padding: 0, border: 0, background: 'transparent', textUnderlineOffset: 4, color: 'var(--hv-brand-ink)', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
        {children}<ArrowR />
    </button>
);

// ---------------------------------------------------------------- project card (Home "Recent" + Projects grid)
const menuItem: React.CSSProperties = { width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', border: 0, borderRadius: 5, background: 'transparent', fontSize: 13, fontWeight: 500, color: 'var(--hv-ink)', cursor: 'pointer', textAlign: 'left' };

export const ProjectMenu: React.FC<{ p: DashProject; onClose: () => void; style?: React.CSSProperties }> = ({ p, onClose, style }) => {
    const dash = useDash();
    const ref = useDismiss<HTMLDivElement>(true, onClose);
    return (
        <div ref={ref} onClick={(e) => e.stopPropagation()} style={{ position: 'absolute', zIndex: 31, width: 180, padding: 6, borderRadius: 8, background: 'var(--hv-card)', border: '1px solid var(--hv-line)', boxShadow: '0 20px 40px -18px var(--hv-shadow)', animation: 'hvPop 0.18s ease both', ...style }}>
            <button type="button" className="hv-mi" style={menuItem} onClick={() => { onClose(); dash.openProject(p); }}>
                <Icon d={p.kind === 'site' ? ICON.site : ICON.video} size={15} />{p.kind === 'site' ? 'Open in studio' : 'Open in editor'}
            </button>
            {p.kind === 'site' && p.publishedUrl && (
                <a href={p.publishedUrl} target="_blank" rel="noopener noreferrer" className="hv-mi" style={{ ...menuItem, textDecoration: 'none' }} onClick={onClose}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v4.5A1.5 1.5 0 0 1 16.5 20h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10" /></svg>
                    Open live site
                </a>
            )}
            {p.kind === 'site' && (
                <button type="button" className="hv-mi" style={menuItem} onClick={() => { onClose(); dash.makeVideoFrom(p); }}>
                    <Icon d={ICON.video} size={15} />Make a video
                </button>
            )}
            {p.kind === 'video' && p.renderUrl && (
                <a href={p.renderUrl} target="_blank" rel="noopener noreferrer" download className="hv-mi" style={{ ...menuItem, textDecoration: 'none' }} onClick={onClose}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 19.5h14" /></svg>
                    Download MP4
                </a>
            )}
            <button type="button" className="hv-mi-danger" style={{ ...menuItem, color: 'var(--hv-danger)' }} onClick={() => { onClose(); void dash.trashProject(p); }}>
                <Icon d={ICON.trash} size={15} />Delete
            </button>
        </div>
    );
};

/** Thumb area of a project: site screenshot, or the design's video frame on a tone. */
export const ProjectThumb: React.FC<{ p: DashProject; height: number; small?: boolean; radius?: string }> = ({ p, height, small, radius = '9px 9px 0 0' }) => {
    const [fw, fh] = (small ? FRAME_SM : FRAME)[p.aspect || '9:16'];
    return (
        <div style={{ position: 'relative', height, borderRadius: radius, borderBottom: '1px solid var(--hv-line)', background: p.kind === 'video' ? toneFor(p.id) : 'var(--hv-page-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            {p.kind === 'site' && p.thumb && <div role="img" aria-label={`${p.name} preview`} style={{ position: 'absolute', inset: 0, backgroundImage: `url("${p.thumb}")`, backgroundSize: 'cover', backgroundPosition: 'top' }} />}
            {p.kind === 'site' && !p.thumb && <Icon d={ICON.site} size={22} style={{ color: 'var(--hv-line-2)' }} />}
            {p.kind === 'video' && (
                <>
                    <div style={{ width: fw, height: fh, borderRadius: 8, background: 'var(--hv-card)', boxShadow: '0 14px 24px -14px var(--hv-shadow)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: small ? 6 : 8, overflow: 'hidden' }}>
                        <span style={{ fontFamily: FONT_SERIF, fontSize: small ? 11 : 14, lineHeight: 1.05, color: 'var(--hv-ink)', letterSpacing: '0.01em', wordSpacing: '0.06em' }}>{p.caption}</span>
                    </div>
                    {fmtDur(p.durationSec) && <span style={{ position: 'absolute', right: 10, bottom: 10, padding: '3px 8px', borderRadius: 999, background: 'rgba(14,42,28,0.78)', color: '#FFFDF7', fontFamily: FONT_SANS, fontSize: 9.5, letterSpacing: '0.06em' }}>{fmtDur(p.durationSec)}</span>}
                </>
            )}
        </div>
    );
};

export const StatusMeta: React.FC<{ p: DashProject }> = ({ p }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, fontSize: 12, color: 'var(--hv-muted)', whiteSpace: 'nowrap' }}>
        <Icon d={p.kind === 'site' ? ICON.site : ICON.video} size={13} sw={2} style={{ flex: 'none' }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{fmtAgo(p.updatedAt)}</span>
        <span style={{ flex: 'none', width: 3, height: 3, borderRadius: 999, background: 'var(--hv-line-2)' }} />
        <span style={{ flex: 'none', display: 'flex', alignItems: 'center', gap: 5, color: 'var(--hv-ink)', fontWeight: 500 }}>
            <span style={{ width: 6, height: 6, borderRadius: 999, background: STATUS_DOT[p.status] }} />
            {STATUS_WORD[p.status]}
        </span>
    </div>
);

export const ProjectCard: React.FC<{ p: DashProject }> = ({ p }) => {
    const dash = useDash();
    const [menu, setMenu] = useState(false);
    return (
        <div className="hv-pcard" role="button" tabIndex={0} onClick={() => dash.openProject(p)} onKeyDown={(e) => { if (e.key === 'Enter') dash.openProject(p); }} style={{ position: 'relative', display: 'flex', flexDirection: 'column', borderRadius: 8, background: 'var(--hv-card)', border: '1px solid var(--hv-line)', cursor: 'pointer' }}>
            <ProjectThumb p={p} height={140} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '11px 8px 12px 14px' }}>
                <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, letterSpacing: '-0.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</div>
                    <StatusMeta p={p} />
                </div>
                <button type="button" data-dismiss-ignore aria-label="Project actions" onClick={(e) => { e.stopPropagation(); setMenu((m) => !m); }} className="hv-iconbtn" style={{ flex: 'none', width: 30, height: 30, borderRadius: 9, border: 0, background: 'transparent', color: 'var(--hv-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                    <Dots />
                </button>
            </div>
            {menu && <ProjectMenu p={p} onClose={() => setMenu(false)} style={{ right: 10, bottom: 48 }} />}
        </div>
    );
};
